import { components } from 'react-select';
import { LOCALES } from 'utils/languageUtils';

const CountriesOptionTemplate = (props) => (
  <components.Option {...props}>
    <div className="county-option">
      {props.data?.image && <img className="county-flag" alt="" src={props.data?.image} loading="lazy" />}
      <span className="county-name">
        {props.selectProps?.language === LOCALES.ENGLISH ? props.data?.en : props.data?.el}
      </span>
    </div>
  </components.Option>
);
export default CountriesOptionTemplate;
